// Angular
import '@angular/platform-browser';
import '@angular/platform-browser-dynamic';
import '@angular/core';
import '@angular/common';
import '@angular/forms';
import '@angular/common/http';
import '@angular/router';

// RxJS
import 'rxjs';

// Other vendors for example jQuery, Lodash or Bootstrap
// You can import js, ts, css, sass, ...
import '@auth0/angular-jwt';
import 'font-awesome/css/font-awesome.css';

import 'bootstrap/dist/css/bootstrap.css'
import '@ng-bootstrap/ng-bootstrap/bundles/ng-bootstrap.js';
import 'ng2-charts/ng2-charts.js';
import 'chart.js/src/chart.js';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/vendor.ts